import React, { useState } from 'react';

/**
 * EditableField
 * Supports both text input and select dropdown editing
 */
const EditableField = ({
  value,
  options,
  onChange,
  placeholder = '',
  maxLength = 100,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleTextChange = (e) => {
    let newValue = e.target.value.replace(/\s{2,}/g, ' ');
    if (newValue.length > maxLength) return;
    if (newValue.trim() !== '') {
      onChange(newValue);
    }
  };

  return isEditing ? (
    options ? (
      <select
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setIsEditing(false);
        }}
        onBlur={handleBlur}
        autoFocus
        style={{
          padding: '8px',
          borderRadius: '4px',
          width: '200px',
          background: '#ffffff',
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    ) : (
      <div style={{ position: 'relative', width: '100%' }}>
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={handleTextChange}
          onBlur={handleBlur}
          autoFocus
          maxLength={maxLength}
          style={{
            padding: '8px',
            fontSize: '16px',
            border: '1px solid #CDD4E2',
            borderRadius: '4px',
            width: '100%',
            textAlign: 'center',
          }}
        />
        <div
          style={{
            textAlign: 'right',
            fontSize: '12px',
            color: '#808081',
            marginTop: '5px',
          }}
        >
          {value?.length}/{maxLength}
        </div>
      </div>
    )
  ) : (
    <span onClick={() => setIsEditing(true)} style={{ cursor: 'pointer' }}>
      {options
        ? options.find((o) => o.value === value)?.label || placeholder
        : value || placeholder}
    </span>
  );
};

export default EditableField;